import React, { forwardRef } from "react";
import { InputNumber, Input } from "antd";
import { Banknote } from "lucide-react";

interface CashPaymentOptionProps {
  cashAmount: number;
  setCashAmount: (amount: number) => void;
  note?: string;
  setNote?: (note: string) => void;
}

export const CashPaymentOption = forwardRef<any, CashPaymentOptionProps>(
  ({ cashAmount, setCashAmount, note, setNote }, ref) => {
    return (
      <div className="border border-gray-150 rounded-xl p-3 bg-white hover:border-indigo-300 transition-all flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="text-xs font-semibold text-gray-700 flex items-center gap-1.5">
            <Banknote className="w-4 h-4 text-emerald-500" /> Cash Payment
          </span>
          {cashAmount > 0 && (
            <span className="text-[10px] bg-emerald-50 text-emerald-600 font-bold px-1.5 py-0.5 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
            Amount
          </label>
          <InputNumber
            ref={ref}
            value={cashAmount}
            onChange={(v) => setCashAmount(v || 0)}
            min={0}
            className="w-full border-gray-200"
            formatter={(v) => `LKR ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(v) => v!.replace(/LKR\s?|(,*)/g, "") as any}
          />
        </div>
        {setNote && (
          <div className="flex flex-col gap-1 mt-1">
            <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
              Payment Notes (Optional)
            </label>
            <Input.TextArea
              value={note || ""}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Add payment notes here..."
              rows={2}
              style={{ resize: "none" }}
              className="border-gray-200"
            />
          </div>
        )}
      </div>
    );
  },
);
